import {
  EventDataFragment,
  UpdateConsultantEventLogEntryMutationVariables,
  useUpdateConsultantEventLogEntryMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useUpdateConsultantEventLogEntry(props: HookProps) {
  const [updateConsultantEventLogEntryMutation] =
    useUpdateConsultantEventLogEntryMutation({
      onError: (error) => {
        console.error(error);
        props.onError && props.onError(error);
      },
      onCompleted: () => {
        props.onCompleted && props.onCompleted();
      }
    });

  const updateConsultantEventLogEntry = (
    args: UpdateConsultantEventLogEntryMutationVariables & { event: EventDataFragment }
  ) => {
    const { event, ...rest } = args;
    props.onBeforeCall && props.onBeforeCall();
    updateConsultantEventLogEntryMutation({
      variables: rest,
      optimisticResponse: (args) => {
        return {
          updateConsultantEvent: {
            ...event,
            UpdatedBy: null,
            Description: args.desc
          }
        };
      }
    });
  };

  return { updateConsultantEventLogEntry };
}
